import { useLocalStorage } from '@cheqroom/hooks';
import { useFeature } from '@optimizely/react-sdk';
import { useMemo } from 'react';

import useOverviewConfig from '../../components/Overview/use-overview-config.hook';
import { useAuth } from '../../context/Authentication.context';
import { FieldType, SystemFieldType } from './types';

export const EXCLUDE_KIT_FIELDS = ['name', 'isRestricted', 'locked'];

const CUSTOMIZE_KIT_VIEW_DEFAULT_SELECTION = [SystemFieldType.barcode, SystemFieldType.qr, SystemFieldType.created];

type SaveKitFieldIds = (ids: FieldType[]) => void;

export const useKitFieldsConfig = (): [FieldType[], SaveKitFieldIds] => {
	const { id: userId } = useAuth();

	const [kitsConfig] = useOverviewConfig<FieldType>({ type: 'kits-list', view: 'table' });

	const storageKey = `${userId!}app.kit-view`;
	const [selectedFieldIds, saveSelectedFieldIds] = useLocalStorage<FieldType[]>(
		storageKey,
		CUSTOMIZE_KIT_VIEW_DEFAULT_SELECTION
	);

	const [isNewKitsOverviewEnabled] = useFeature('kits_overview_refactor');

	const inlineFields = useMemo(() => {
		return (
			isNewKitsOverviewEnabled
				? (kitsConfig?.inlineFields ?? [])
				: (selectedFieldIds?.map((id) => {
						// Temporary support for renaming of old legacy fields
						// @ts-expect-error - temporary support for renaming of old legacy fields
						if (id === 'qr') {
							return 'codes';
						}
						// @ts-expect-error - temporary support for renaming of old legacy fields
						if (id === 'barcode') {
							return 'barcodes';
						}

						return id;
					}) as FieldType[])
		).filter((field) => !EXCLUDE_KIT_FIELDS.includes(field));
	}, [kitsConfig?.inlineFields, selectedFieldIds, isNewKitsOverviewEnabled]);

	return [inlineFields, saveSelectedFieldIds];
};

export default useKitFieldsConfig;
